import { render, staticRenderFns } from "./Menu_Setting.vue?vue&type=template&id=8f21925a&scoped=true&"
import script from "./Menu_Setting.vue?vue&type=script&lang=js&"
export * from "./Menu_Setting.vue?vue&type=script&lang=js&"
import style0 from "./Menu_Setting.vue?vue&type=style&index=0&id=8f21925a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f21925a",
  null
  
)

export default component.exports